import React, {useEffect, useRef, useState} from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'
import ExperienceProfile from './ExperienceProfile/ExperienceProfile'
import InfoProfile from './InfosProfile/InfoProfile'
import LanguageProfile from './LanguageProfile/LanguageProfile'
import SkillsAndHobbiesProfile from './SkillsAndHobbiesProfile/SkillsAndHobbiesProfile'
import FeedbackSnackbar from 'components/FeedbackSnackbar/FeedbackSnackbar'
import Paper from 'components/Paper/Paper'
import Button from 'components/Button/Button'
import IconFactory from 'icons/IconFactory/IconFactory'
import ProgressCircle from 'components/ProgressCircle/ProgressCircle'
import UploadDocument from 'containers/UploadDocument/UploadDocument'
import ProfilePassport from 'pages/user/PersonalDashboard/components/ProfilePassport/ProfilePassport'
import { useStyles } from './StudentProfile_style'
import { FormattedMessage } from 'react-intl'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ResumeParserModal from 'shared/modals/ResumeParserModal/ResumeParserModal'

const StudentProfilePageView = (props) => {
    const {
        blankLanguage,
        closeFeedback,
        disabledSave,
        feedback,
        handleDateBlur,
        handleDateChange,
        handleSubmit,
        imageArray,
        loading,
        errors,
        errorTypes,
        pictureId,
        user,
        profile,
        selectedDate,
        setExperienceIsUpdated,
        setImageArray,
        setStudent,
        setStudentFormation,
        setStudentLanguage,
        setStudentSkillsAndHobbies,
        student,
        studentFormation,
        studentLanguage,
        studentSkillsAndHobbies
    } = props

    const classes = useStyles()

    const currentUrl = new URL(window.location.href)
    const profileCompletedWithParser = new URLSearchParams(currentUrl.search).get('parser_result')
    const [modalOpen, setModalOpen] = useState(new URLSearchParams(currentUrl.search).get('modal_open'))

    const handleCloseModal = () => {
        setModalOpen(false)
    }

    return (
        <Container maxWidth='lg' className={classes.profileFormContainer}>
            <FeedbackSnackbar
                open={feedback.open}
                message={feedback.message}
                closeFeedback={closeFeedback}
                severity={feedback.severity}
            />
            {loading
                ? <ProgressCircle/>
                : <Box mb={5}>
                    <ResumeParserModal
                        open={modalOpen}
                        handleClose={handleCloseModal}
                    />
                    <form onSubmit={handleSubmit} noValidate>
                        <Grid container spacing={1}>
                            <Grid item xs={12} className={classes.saveButtonContainer}>
                                {profileCompletedWithParser &&
                                    <Box className={classes.aiCheckAlert}>
                                        <FormattedMessage id='landing_student_profile_page.ai_alert'/>
                                        <IconFactory className={classes.alertIconMain} icon="circle-exclamation"/>
                                    </Box>
                                }
                                <div className="my-items-selection-container">
                                    <Box display='flex' justifyContent='flex-end'>
                                        <Box component={Grid} container item xs={12} justifyContent='flex-end'>
                                            <Button
                                                variant='primary'
                                                size='small'
                                                type='submit'
                                            >
                                                <Box className={classes.saveButton}>
                                                    <FormattedMessage id="landing_student_profile_page.save_change" />
                                                    <IconFactory icon='save' />
                                                </Box>
                                            </Button>
                                        </Box>
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} >
                                    <Grid item xs={12} sm={12} md={4}>
                                        <Grid container spacing={2}>
                                            {/* START AVATAR + JOB SEARCH STATUS */}
                                            <Grid item xs={12}>
                                                <ProfilePassport
                                                    context='student_profile'
                                                    user={user}
                                                    profileId={profile.id}
                                                    pictureId={pictureId}
                                                >
                                                    <Box className={classes.paper} >
                                                        <InfoProfile
                                                            setStudent={setStudent}
                                                            student={student}
                                                            selectedDate={selectedDate}
                                                            handleDateChange={handleDateChange}
                                                            handleDateBlur={handleDateBlur}
                                                            disabledSave={disabledSave}
                                                            errors={errors}
                                                        />
                                                    </Box>
                                                </ProfilePassport>
                                            </Grid>
                                            {/* START DOCUMENTS */}
                                            <Grid item xs={12}>
                                                <Paper className={classes.paper}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <Typography variant='h2' component='div'>
                                                                <FormattedMessage id="landing_student_profile_page.my_documents" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant={'caption'} component='div'>
                                                                <FormattedMessage id="landing_student_profile_page.download_documents" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <UploadDocument
                                                                page='studentProfile'
                                                                profileId={profile.id}
                                                                imageArray={imageArray}
                                                                setImageArray={setImageArray}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                            </Grid>
                                            {/* END DOCUMENTS */ }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={8}>
                                        <Grid container spacing={1} className={classes.accordionGrid}>
                                            <Accordion className={errorTypes?.includes('experiences_error') ? classes.sectionError : classes.accordion}>
                                                <AccordionSummary expandIcon={<IconFactory icon='more' />}>
                                                    <Typography variant='h3' component={'div'} className={classes.collapsed}>
                                                        <FormattedMessage id='landing_experience_profile.studies' />
                                                        <IconFactory icon="graduation-cap" className={classes.icon} />
                                                    </Typography>
                                                    {profileCompletedWithParser && <IconFactory className={classes.alertIcon} icon="circle-exclamation"/>}
                                                </AccordionSummary>
                                                <ExperienceProfile
                                                    disabledSave={disabledSave}
                                                    errors={errors}
                                                    setStudentFormation={setStudentFormation}
                                                    studentFormation={studentFormation}
                                                    setExperienceIsUpdated={setExperienceIsUpdated}
                                                />
                                            </Accordion>
                                            <Accordion className={errorTypes?.includes('language_error') ? classes.sectionError : classes.accordion}>
                                                <AccordionSummary expandIcon={<IconFactory icon='more' />}>
                                                    <Typography variant='h3' component={'div'} className={classes.collapsed}>
                                                        <FormattedMessage id='landing_language_profile.language_skills' />
                                                        <IconFactory icon="language" className={classes.icon} />
                                                        {profileCompletedWithParser && <IconFactory className={classes.alertIcon} icon="circle-exclamation"/>}
                                                    </Typography>
                                                </AccordionSummary>
                                                <LanguageProfile
                                                    blankLanguage={blankLanguage}
                                                    disabledSave={disabledSave}
                                                    setStudent={setStudent}
                                                    setStudentLanguage={setStudentLanguage}
                                                    student={student}
                                                    studentLanguage={studentLanguage}
                                                />
                                            </Accordion>
                                            <Accordion className={classes.accordion}>
                                                <AccordionSummary expandIcon={<IconFactory icon='more' />}>
                                                    <Typography variant='h3' component={'div'} className={classes.collapsed}>
                                                        <FormattedMessage id='landing_skills_and_hobbies_profile.skills_and_hobbies' />
                                                        <IconFactory icon="chess-knight" className={classes.icon} />
                                                        {profileCompletedWithParser && <IconFactory className={classes.alertIcon} icon="circle-exclamation"/>}
                                                    </Typography>
                                                </AccordionSummary>
                                                <SkillsAndHobbiesProfile
                                                    disabledSave={disabledSave}
                                                    setStudentSkillsAndHobbies={setStudentSkillsAndHobbies}
                                                    studentSkillsAndHobbies={studentSkillsAndHobbies}
                                                />
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            }
        </Container>
    )
}

export default StudentProfilePageView
